import { isObject } from '@impuls-coach/util-is';
import AbstractModel, { Types } from 'models/Abstract';

export default class EventWrapper<TData = any> extends AbstractModel {
	public static requiredFields: any = {
		data: Types.object,
		events: Types.object,
	};

	public static defaultValues: any = {
		data: {},
		events: [],
	};

	public data: any;
	public events: any[];

	constructor(data: any) {
		super(data);

		this.data = data.data;
		this.events = data.events;
	}

	get hasData(): boolean {
		return !!isObject(this.data);
	}

	get hasEvents(): boolean {
		return !!(this.events.length > 0);
	}

	get dataSize(): number {
		try {
			if (isObject(this.data)) {
				return Object.keys(this.data).length;
			}
		} catch (err) {
			// do nothing
		}

		return -1;
	}

	public getData(): TData {
		return this.data;
	}

	public getEvents() {
		return this.events || [];
	}
}
